import { render, staticRenderFns } from "./Papillon.vue?vue&type=template&id=1512b844"
import script from "./Papillon.vue?vue&type=script&lang=js"
export * from "./Papillon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports